// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".full-banner[data-v-3b35c6e0]{position:relative;width:100%;height:100%}.full-link[data-v-3b35c6e0]{display:block;width:100%;height:100%}.full-banner-bg[data-v-3b35c6e0]{z-index:-1;width:100%;height:100%}.banner-text[data-v-3b35c6e0],.full-banner-bg[data-v-3b35c6e0]{position:absolute;top:0;right:0;bottom:0;left:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
